import TopNav from "ui/dashboard/topnav";
import { SvgRemove, SvgToastInfo } from "ui/svgs";
import { TrashIcon } from "@heroicons/react/24/outline";
import { useContext, useEffect, useRef, useState } from "react";
import { releaseVersion, uploadFile } from "lib/actions";
import { AuthContext } from "context/AuthContext";
import Modal from "react-modal";
import useSWR from "swr";
import { fetchWithParams } from "lib/fetcher";
import { useDebouncedCallback } from "use-debounce";
import { SvgChecked } from "ui/svgs";
import { showToast } from "ui/components/common";
import { set } from "date-fns";
import { ConfirmModalStyles } from "lib/constants";

enum UploadState {
  UN_SELECTED,
  SELECTED,
  UPLOADING,
  UPLOADED,
  ERROR,
}

export default function Page() {
  const { user } = useContext(AuthContext);
  const fileInput = useRef<HTMLInputElement>();
  const tbody = useRef<HTMLTableSectionElement>();

  const [inputVision, setInputVision] = useState("");
  const [inputService, setInputService] = useState("nvr");
  const [fileName, setFileName] = useState("");
  const [uploadState, setUploadState] = useState(UploadState.UN_SELECTED);

  const [queryService, setQueryService] = useState("nvr");
  const [queryVision, setQueryVersion] = useState("");
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  const [currentService, setCurrentService] = useState("");
  const [currentVision, setcurrentVersion] = useState("");
  const [randomKey, setRandomKey] = useState("");

  function fileChange(event) {
    const selectedFiles = (event.target as HTMLInputElement).files;
    if (selectedFiles?.length > 0) {
      console.log("selected file: ", selectedFiles[0].size);
      if (selectedFiles[0].size > 1024 * 1024 * 512) {
        alert("The file size exceeds the limit of 512MB, please reselect");
        fileInput.current.value = "";
        return;
      }
      setFileName(selectedFiles[0].name);
      if (inputService === "nvr" && selectedFiles[0].name.endsWith(".bin")) {
        const name = selectedFiles[0].name.replace(".bin", "");
        setInputVision(name);
      } else if (
        (inputService === "nvr_edge" || inputService === "nvr_daemon") &&
        selectedFiles[0].name.endsWith(".tar.gz")
      ) {
        const pos = selectedFiles[0].name?.indexOf("-linux");
        pos >= 0 && setInputVision(selectedFiles[0].name.slice(0, pos));
      }

      setUploadState(UploadState.SELECTED);
    } else {
      setUploadState(UploadState.UN_SELECTED);
      setFileName("");
      setInputVision("");
    }
  }

  function uploadFileClicked() {
    if (!fileInput?.current || !fileInput?.current?.files) {
      return;
    }
    const file = fileInput?.current?.files[0];
    if (file) {
      console.log("upload file: ", file);
      const reader = new FileReader();
      reader.onload = async function () {
        const formData = new FormData();
        formData.append("service", inputService);
        formData.append("version", inputVision);
        formData.append("force", "false");
        formData.append("file", file);

        for (const [key, value] of formData.entries()) {
          console.log(key, value);
        }

        setUploadState(UploadState.UPLOADING);
        try {
          await uploadFile(user.orgId, formData);
          showToast(0, "Upload file successfully!.");
          setUploadState(UploadState.UPLOADED);
          setRandomKey(Math.random().toString());
        } catch (e) {
          showToast(
            1,
            "There was a problem uploading your file. Please try again.",
          );
          setUploadState(UploadState.ERROR);
        }
      };

      reader.onerror = function (event) {
        console.error("read data error:", event.target.error);
      };

      reader.readAsArrayBuffer(file);
    }
  }
  const { data, error, isLoading } = useSWR(
    [
      `service/software_list/group?service=${queryService}&version=${queryVision}`,
      user.token,
      user.orgId,
      randomKey,
    ],
    ([url, token, orgId]) => fetchWithParams(url, token, orgId),
    {
      revalidateOnFocus: false,
      revalidateIfStale: true,
    },
  );

  const handleVersionChange = useDebouncedCallback((term) => {
    setQueryVersion(term);
  }, 300);

  return (
    <>
      <TopNav title="Upload" />
      <div className="flex-grow pr-6 pb-6 w-full">
        <div className="w-full h-full p-6 rounded-3xl bg-white ">
          <div className="p-5 flex flex-col  max-h-full">
            <h2 className="mb-2 text-lg font-medium">Upload</h2>
            <div className="mb-3 flex h-9 items-center ">
              <span>Service Type:</span>
              <input
                className="ml-2"
                type="radio"
                name="options"
                onChange={(e) => {
                  setInputService(e.target.value);
                }}
                value="nvr"
                checked={inputService === "nvr"}
              />
              <span className="ml-1">nvr</span>

              <input
                className="ml-4"
                type="radio"
                name="options"
                onChange={(e) => {
                  setInputService(e.target.value);
                }}
                checked={inputService === "nvr_edge"}
                value="nvr_edge"
              />
              <span className="ml-1 ">nvr_edge</span>

              <input
                className="ml-4"
                type="radio"
                name="options"
                onChange={(e) => {
                  setInputService(e.target.value);
                }}
                checked={inputService === "nvr_daemon"}
                value="nvr_daemon"
              />
              <span className="ml-1 ">nvr_daemon</span>
            </div>
            <div className="mb-3 flex h-9 items-center">
              <label>Select a File:</label>
              {uploadState === UploadState.UN_SELECTED && (
                <button
                  className="rounded-md bg-white h-full px-2 border ml-2  mr-2 border-blue-500 hover:border-blue-400 text-sm  transition-colors text-blue-500 hover:text-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
                  onClick={() => {
                    fileInput?.current.click();
                  }}
                >
                  Browse
                </button>
              )}
              {uploadState !== UploadState.UN_SELECTED && (
                <span className="relative hover:text-blue-200 cursor-pointer group rounded text-blue-500">
                  {fileName}
                  <button
                    className="rounded-md absolute top-1/2 left-1/2 invisible group-hover:visible -translate-x-2/4 -translate-y-2/4"
                    onClick={() => {
                      setFileName("");
                      setInputVision("");
                      setUploadState(UploadState.UN_SELECTED);
                      fileInput.current.value = "";
                      console.log(fileInput);
                    }}
                  >
                    <SvgRemove width="20" className={"fill-zinc-500"} />
                  </button>
                </span>
              )}

              <input
                type="file"
                ref={fileInput}
                onChange={fileChange}
                className="invisible w-1"
              />
            </div>
            <div className="mb-3">
              <label>Version Name:</label>
              <input
                className="w-[300px] rounded-md border border-gray-200 ml-2 px-3 py-2 text-sm outline-2 placeholder:text-gray-500"
                name="version"
                placeholder="Input the version name"
                value={inputVision}
                onChange={(e) => {
                  setInputVision(e.target.value);
                }}
              />
            </div>
            <div className="flex items-center">
              {uploadState === UploadState.UPLOADED && (
                <>
                  <span className="mr-2 text-zinc-700 font-medium">
                    {" "}
                    Upload completed
                  </span>
                  <SvgChecked width="17" className="fill-emerald-600" />
                </>
              )}
              {uploadState === UploadState.ERROR && (
                <>
                  <span className="mr-2 text-zinc-700 font-medium">
                    {" "}
                    Upload failed
                  </span>
                  <SvgToastInfo width="17" className="fill-red-500" />
                </>
              )}
              {(uploadState == UploadState.UN_SELECTED ||
                uploadState == UploadState.SELECTED ||
                uploadState == UploadState.UPLOADING) && (
                <button
                  className="flex items-center justify-center h-9 w-[92px] rounded-md bg-blue-500 hover:bg-blue-400 border-none text-white text-base disabled:bg-blue-300 disabled:hover:bg-blue-300 disabled:cursor-not-allowed disabled:opacity-50 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
                  onClick={uploadFileClicked}
                  disabled={
                    uploadState === UploadState.UN_SELECTED ||
                    uploadState === UploadState.UPLOADING ||
                    (uploadState == UploadState.SELECTED && inputVision === "")
                  }
                >
                  {uploadState === UploadState.UPLOADING ? (
                    <div
                      className="ml-1 text-blue-500  inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                      role="status"
                    ></div>
                  ) : (
                    "Upload"
                  )}
                </button>
              )}
            </div>
            <div className="h-[1px] w-full mt-3 bg-gray-300"></div>
            <h2 className="mt-6 mb-2 text-lg font-medium">Software List</h2>

            <div>
              <input
                type="radio"
                id="queryOption1"
                name="queryOptions"
                value="nvr"
                checked={queryService === "nvr"}
                onChange={(e) => {
                  setQueryService(e.target.value);
                }}
              />
              <label className="ml-1">nvr</label>
              <input
                className="ml-1"
                type="radio"
                id="queryOption2"
                name="queryOptions"
                value="nvr_edge"
                checked={queryService === "nvr_edge"}
                onChange={(e) => {
                  setQueryService(e.target.value);
                }}
              />
              <label className="ml-1">nvr_edge</label>
              <input
                className="ml-1"
                type="radio"
                id="queryOption2"
                name="queryOptions"
                value="nvr_daemon"
                checked={queryService === "nvr_daemon"}
                onChange={(e) => {
                  setQueryService(e.target.value);
                }}
              />
              <label className="ml-1">nvr_daemon</label>

              <input
                placeholder="search version"
                className="ml-3 w-[300px] rounded-md border border-gray-200 px-3 py-2 text-sm outline-2 placeholder:text-gray-500"
                onChange={(e) => {
                  handleVersionChange(e.target.value);
                }}
              />
            </div>
            <table className="min-w-full rounded-md text-neutral-800 border-separate border-spacing-y-3 flex-grow">
              <thead>
                <tr>
                  <th className="bg-neutral-100 text-sm px-4 py-4">
                    Software Type
                  </th>
                  <th className="bg-neutral-100 text-sm px-8 py-4">
                    Version Name
                  </th>
                  {queryService === "nvr" && (
                    <th className="bg-neutral-100 text-sm px-12 py-4">
                      Models
                    </th>
                  )}
                  <th className="bg-neutral-100 text-sm px-8 py-4">
                    Is Target
                  </th>
                  <th className="bg-neutral-100 text-sm px-8 py-4">Action</th>
                </tr>
              </thead>
              <tbody ref={tbody}>
                {data?.data?.map((e) => {
                  return (
                    <tr key={e.version}>
                      <td className="text-center">{e.service}</td>
                      <td className="text-center">{e.version}</td>
                      {queryService === "nvr" && (
                        <td className="text-center text-sm">
                          {e.meta?.models?.map((m) => <div>{m}</div>)}
                        </td>
                      )}
                      <td className="text-center">
                        {e.isTarget ? "Yes" : "No"}
                      </td>
                      <td className="text-center">
                        <button
                          className="text-blue-600 hover:text-blue-500 underline"
                          onClick={async () => {
                            console.log("release button clicked！", e);
                            setCurrentService(e.service);
                            setcurrentVersion(e.version);
                            setConfirmModalOpen(true);
                          }}
                        >
                          release
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              {isLoading && (
                <thead>
                  <tr>
                    <td>
                      <div
                        className="ml-1 text-blue-500  inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                        role="status"
                      ></div>
                    </td>
                  </tr>
                </thead>
              )}
              {error && (
                <thead>
                  <tr>
                    <td>
                      <div>Something error</div>
                    </td>
                  </tr>
                </thead>
              )}
              {data?.data?.length === 0 && !isLoading && !error && (
                <div>No data</div>
              )}
            </table>
            {data?.data?.length > 20 && (
              <div className="text-center mt-4 text-sm text-slate-400">
                Display up to 20 data
              </div>
            )}
          </div>
        </div>
        <Modal
          isOpen={confirmModalOpen}
          style={ConfirmModalStyles}
          contentLabel="Example Modal"
        >
          <h1 className="text-xl font-bold">About to release the software</h1>
          <div className="text-base mt-4 break-words break-all">{`This software [${currentService}-${currentVision}] will be released`}</div>
          <div className="float-right mt-6">
            <button
              className="rounded-2xl bg-white px-6 py-4 border border-blue-500 hover:border-blue-400 text-sm  transition-colors text-blue-500 hover:text-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
              onClick={() => {
                setConfirmModalOpen(false);
              }}
            >
              Cancel
            </button>
            <button
              className="ml-4 rounded-2xl px-6 py-4 bg-blue-500 text-sm font-medium text-white transition-colors hover:bg-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
              onClick={async () => {
                try {
                  const res = await releaseVersion(
                    user.orgId,
                    currentService,
                    currentVision,
                  );
                  console.log("release response:", res);
                  setRandomKey(Math.random().toString());
                  showToast(
                    0,
                    "Release success! service: " +
                      currentService +
                      " version: " +
                      currentVision,
                  );
                } catch (e) {
                  showToast(
                    1,
                    "There was a problem releasing the software. Please try again.",
                  );
                }
                setConfirmModalOpen(false);
              }}
            >
              Release
            </button>
          </div>
        </Modal>
      </div>
    </>
  );
}
